import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';
import { authConfig } from './../../../auth/auth.config';

@NgModule({
    imports: [
        AuthModule.forRoot({ config: authConfig.config })
    ],
    exports: [AuthModule]
})
export class AdminAuthModule { }

